import React, { memo, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import useDebounceCallback from 'hooks/useDebounceCallback';
import ManufacturerSvg from 'images/v5/icons/menu/manufacturers.svg';
import LoopSvg from 'images/v5/icons/search-md.svg';
import Avatar from 'layout/atoms/Avatar/Avatar';
import Button from 'layout/atoms/Button/Button';
import Input from 'layout/atoms/Input/Input';
import Label from 'layout/atoms/Label';
import Loader from 'layout/atoms/Loader/Loader';
import Modal from 'layout/atoms/Modal/Modal';
import Grid from 'layout/molecules/Grid/Grid';
import { useAppDispatch } from 'store/index';
import { selectModalByName } from 'store/layoutSlice';
import { fetchManufacturers, resetFilters, resetManufacturers, selectManufacturers, selectManufacturersStatus, setFilter, } from 'store/manufacturersSlice';
import { selectOrderDetailsItem } from 'store/orderDetailsSlice';
import { setOrderSpecificationManufacturer } from 'store/orderProductionManagerSlice';
import env from 'utils/env';
function AssignManufacturer() {
    var _a;
    const { t } = useTranslation(['orders', 'common']);
    const dispatch = useAppDispatch();
    const [searchQuery, setSearchQuery] = useState('');
    const orderDaetials = useSelector(selectOrderDetailsItem);
    const modalData = (_a = useSelector(selectModalByName('assignManufacturer'))) === null || _a === void 0 ? void 0 : _a.data;
    const status = useSelector(selectManufacturersStatus);
    const manufacturers = useSelector(selectManufacturers).items;
    const filters = useSelector((state) => state.manufacturers.filters);
    const debouncedSearch = useDebounceCallback((searchQuery) => {
        dispatch(setFilter({ filterName: 'name', value: searchQuery }));
    }, 1000);
    const handleSearchFilter = (e) => {
        const newQuery = e.target.value;
        setSearchQuery(newQuery);
        debouncedSearch(newQuery);
    };
    // Initialize modal - reset filters and fetch data
    useEffect(() => {
        setSearchQuery('');
        dispatch(resetFilters());
        dispatch(resetManufacturers());
        dispatch(fetchManufacturers());
    }, [dispatch]);
    // Refetch data when filters change
    useEffect(() => {
        if (filters.name !== null) {
            dispatch(resetManufacturers());
            dispatch(fetchManufacturers());
        }
    }, [filters.name, dispatch]);
    const handleSubmit = (manufacturer) => {
        var _a, _b, _c, _d, _e;
        if (!(orderDaetials === null || orderDaetials === void 0 ? void 0 : orderDaetials.id) || !(modalData === null || modalData === void 0 ? void 0 : modalData.specificationId)) {
            return;
        }
        dispatch(setOrderSpecificationManufacturer({
            orderId: orderDaetials.id,
            specificationId: modalData.specificationId,
            manufacturerId: manufacturer.id,
            manufacturer: {
                id: manufacturer.id,
                shortName: (_b = (_a = manufacturer.shortName) !== null && _a !== void 0 ? _a : manufacturer.name) !== null && _b !== void 0 ? _b : null,
                fullName: (_c = manufacturer.fullName) !== null && _c !== void 0 ? _c : null,
                employeesCount: (_d = manufacturer.employeesCount) !== null && _d !== void 0 ? _d : null,
                picture: (_e = manufacturer.picture) !== null && _e !== void 0 ? _e : null,
            },
        }));
        dispatch({ type: 'layout/closeModal', payload: { name: 'assignManufacturer' } });
    };
    return (React.createElement(Modal, { alwaysScroll: true, name: "assignManufacturer", size: "xs", header: React.createElement(Label, { weight: "strong" },
            React.createElement(ManufacturerSvg, null),
            t('ASSIGN_MANUFACTURER')) },
        React.createElement(Grid, { columns: 1, gap: 24 },
            React.createElement(Input, { leftIcon: React.createElement(LoopSvg, null), placeholder: t('search'), value: searchQuery, onChange: handleSearchFilter }),
            status === 'idle' || status === 'loading' ? (React.createElement(Loader, null)) : (React.createElement(Grid, { columns: 1, gap: 6 }, manufacturers.map((manufacturer) => {
                var _a;
                const pictureSrc = manufacturer.picture
                    ? `${env.static}/${manufacturer.picture}`
                    : null;
                return (React.createElement(Button, { align: "left", key: manufacturer.id, leftIcon: React.createElement(Avatar, { src: pictureSrc, userName: manufacturer.name }), theme: "ghost", onClick: () => handleSubmit(manufacturer) },
                    manufacturer.fullName,
                    " (", (_a = manufacturer.employeesCount) !== null && _a !== void 0 ? _a : 0,
                    ")"));
            }))))));
}
export default memo(AssignManufacturer);
